module.exports = __webpack_public_path__ + "static/media/paygos.3e8c61b3.svg";